import styles from './PickerForm.module.scss';
import { PickerFormItem, SelectedItemListProps } from './PickerFormTypes';
import Button from '../../../common/Button/Button';
import { Label } from '../../../common/Label/Label';
import { FORM_PICKER_LABELS } from '../../../../lib/constants/labelKeys';
import { useUI } from '../../../../lib/hooks/useUI';
import { pickerFormIds } from '../../../../lib/tests/testIds';

const SelectedItemsList = ({ value, selectedItems, deselectItem, labels, summaryId }: SelectedItemListProps) => {
  const findValue = (item: PickerFormItem) =>
    value.find(val => val.list.some(current => val.idFunction(item) === val.idFunction(current)));

  const render = (item: PickerFormItem) => findValue(item)?.render(item);
  const { device } = useUI();

  if (!selectedItems.length && device === 'desktop') {
    return <div className={styles.emptySelectedList}>{labels.noItemsSelectedMessage}</div>;
  }

  return (
    <ul className={styles.selectedItemsList} aria-details={summaryId} data-testid={pickerFormIds.selectedItemsList}>
      {selectedItems.map(item => (
        <li className={styles.selectedListItem} key={item.id}>
          {render(item)}
          <Button variant="outlined" onClick={() => deselectItem(item)} className={styles.listButton}>
            <Label name={FORM_PICKER_LABELS.DESELECT_BUTTON} />
          </Button>
        </li>
      ))}
    </ul>
  );
};

export default SelectedItemsList;
